import Auth from '@getgo/auth-client';
import AppConstants from '../AppConstants';
import uuidV4 from 'uuid/v4';
import { Base64 } from 'js-base64';
import { clearSessionStorage, getSessionStorage, setSessionStorage } from '../Utils/SessionStorage';

const EXPIRY_INSTANT_KEY = 'expiry_instant';
const ACCESS_TOKEN_KEY = 'access_token';
const AUTH_STATE = 'auth_state';
const SEND_MIXPANEL_LOGIN_EVENT = 'sendMixpanelLoginEvent';

const options = {
  client_id: AppConstants.AUTH_CLIENT_ID,
  url: AppConstants.AUTH_SERVICE_BASE_URL,
  redirect_url: AppConstants.AUTH_REDIRECT_URL
};
const auth = new Auth(options);

const token = auth.init();

export function login(location) {
  clearAccessToken();
  clearExpiryInstant();
  let { pathname, search, hash } = location || window.location;
  let uuid = uuidV4();
  auth.options.state = Base64.encodeURI(JSON.stringify({ uuid, pathname, search, hash }));
  setSessionStorage(AUTH_STATE, auth.options.state);
  auth.login();
}

export function verifyStateAndGetRedirectLocation() {
  let authState = getSessionStorage(AUTH_STATE);
  let finalRedirection = '/';
  if (token && token.state && authState && authState === token.state) {
    finalRedirection = getRedirectionString(authState) || finalRedirection;
    setAccessToken();
    setExpiryInstant();
    setMixpanelLoginEventToBeSent('true');
  }
  clearSessionStorage(AUTH_STATE);
  return finalRedirection;
}

function getRedirectionString(authState) {
  let { pathname, search, hash } = JSON.parse(Base64.decode(authState));
  return [pathname, search, hash].join('');
}

export function logout() {
  clearAccessToken();
  clearExpiryInstant();
  auth.logout();
}

export function isLoggedIn() {
  const expiryInstantString = getExpiryInstant();
  const accessToken = getAccessToken();
  return accessToken && expiryInstantString && Number(expiryInstantString) > Date.now();
}

export function getExpiryInstant() {
  return localStorage.getItem(EXPIRY_INSTANT_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function clearExpiryInstant() {
  localStorage.removeItem(EXPIRY_INSTANT_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

function setAccessToken() {
  if (token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token.access_token);
  }
}

function setExpiryInstant() {
  if (token) {
    localStorage.setItem(EXPIRY_INSTANT_KEY, token.expires.toString());
  }
}

export function setMixpanelLoginEventToBeSent(value) {
  localStorage.setItem(SEND_MIXPANEL_LOGIN_EVENT, value);
}

export function shouldMixpanelLoginEventBeSent() {
  return (
    localStorage.getItem(SEND_MIXPANEL_LOGIN_EVENT) !== null &&
    localStorage.getItem(SEND_MIXPANEL_LOGIN_EVENT) === 'true'
  );
}



// WEBPACK FOOTER //
// ./src/Authentication/AuthenticationService.js